export class G1N5 {
  areaVisible: number | null
  corrosionCoatingFailure: number | null
  totalArea: number | null
  corrosionType: 'local' | 'scattered' | ''
  level2InspectionRequired: boolean
  picturesTaken: number | null
  pictureFileNames: string
  comments: string
  coatingCondition: 'P1' | 'P2' | 'P3' | 'P4' | ''

  constructor() {
    this.areaVisible = null
    this.corrosionCoatingFailure = null
    this.totalArea = null
    this.corrosionType = ''
    this.level2InspectionRequired = false
    this.picturesTaken = null
    this.pictureFileNames = ''
    this.comments = ''
    this.coatingCondition = ''
  }

  /* eslint-disable @typescript-eslint/no-explicit-any */
  static fromJSON(json: any): G1N5 {
    const gn15 = new G1N5()
    // Map defect type booleans
    if (json.areaVisible !== undefined) gn15.areaVisible = json.areaVisible
    if (json.corrosionCoatingFailure !== undefined)
      gn15.corrosionCoatingFailure = json.corrosionCoatingFailure
    if (json.totalArea !== undefined) gn15.totalArea = json.totalArea
    if (json.corrosionType !== undefined)
      gn15.corrosionType = json.corrosionType
    if (json.level2InspectionRequired !== undefined)
      gn15.level2InspectionRequired = json.level2InspectionRequired
    if (json.picturesTaken !== undefined)
      gn15.picturesTaken = json.picturesTaken
    if (json.pictureFileNames !== undefined)
      gn15.pictureFileNames = json.pictureFileNames
    if (json.comments !== undefined) gn15.comments = json.comments
    if (json.coatingCondition !== undefined)
      gn15.coatingCondition = json.coatingCondition
    return gn15
  }

  static toJSON(gn15: G1N5): any {
    return {
      areaVisible: gn15.areaVisible,
      corrosionCoatingFailure: gn15.corrosionCoatingFailure,
      coatingCondition: gn15.coatingCondition,
      totalArea: gn15.totalArea,
      corrosionType: gn15.corrosionType,
      level2InspectionRequired: gn15.level2InspectionRequired,
      picturesTaken: gn15.picturesTaken,
      pictureFileNames: gn15.pictureFileNames,
      comments: gn15.comments,
    }
  }
}
